export function parseQmsTags(value: string): string[] {
  return value
    .split(',')
    .map((tag) => tag.trim())
    .filter(Boolean);
}

export function formatQmsTags(tags?: string[]): string {
  return tags?.join(', ') || '';
}
